module.exports = "/images/vendor/vue2vis/dist/deleteIcon.png?02d321edc6e03aea1675001899d8f479";